import React, { useEffect, useState } from 'react'
import { string, number } from 'prop-types'

import styles from './index.module.css'

export default function ScoreItem(props) {
  const { digit, delay } = props
  const [styleObj, setStyleObj] = useState({})

  const arr = []
  for (let i = 0; i <= 9; i++) {
    arr.push(i)
  }
  for (let i = 0; i <= +digit; i++) {
    arr.push(i)
  }
  const y =
    (arr.length - 1) * (176 / 750) * document.documentElement.clientWidth

  useEffect(() => {
    setTimeout(() => {
      setStyleObj({
        transitionDuration: `${delay + 1}s`,
        transform: `translateY(-${y}px)`
      })
    }, 100)
    // eslint-disable-next-line
  }, [])

  console.log('reader scoreItem')
  return (
    <div className={styles.cntr}>
      <div className={styles.numCntr} style={styleObj}>
        {arr.map((num, idx) => (
          <div key={idx} className={styles.item}>
            {num}
          </div>
        ))}
      </div>
    </div>
  )
}

ScoreItem.propTypes = {
  digit: string,
  delay: number
}
